import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

export function hasSufficientFeatures(
    requiredFeatures: RbacFeature[],
    availableFeatures: Record<RbacFeature, boolean>,
    requiredAny?: boolean,
): boolean {
    const hasFeature = (feature: RbacFeature) => availableFeatures?.[feature] ?? false;
    return requiredAny
        ? requiredFeatures.some(hasFeature)
        : requiredFeatures.every(hasFeature);
}
